import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CarryoverApprovalStatus } from '../../../../enums/carryover-approval-status.enum';
import { JobScreenCarryOverTaskCheck } from '../../../../interfaces/screen-specific/job-screen';

@Injectable({
  providedIn: 'root',
})
export class CarryoverApprovalService {
  constructor(protected http: HttpClient) {}

  setCarryoverApprovalStatus(request: SetCarryoverApprovalStatusRequest) {
    return this.http.post<any>(`/api/carryover/change-approval-status`, request).toPromise();
  }

  checkCarryOverConditions(jobId: number, supplierId: number) {
    const params = new HttpParams()
      .set('jobId', jobId.toString())
      .set('supplierId', supplierId.toString());

    return this.http
      .get<JobScreenCarryOverTaskCheck[]>('/api/carryover/approval-checks', { params })
      .toPromise();
  }
}

export class SetCarryoverApprovalStatusRequest {
  carryoverApprovalStatus: CarryoverApprovalStatus;
  taskId: number;
  reason: string;
}
